
import styled from "styled-components"
import { useDispatch, useSelector } from "react-redux";
import { clearNakliyeCalcForm, setControlContainer, setIsDurationStrict, updateActiveExtraPriceList, updateKmData, updateSelectedRouteItem } from "../../../features/nakliyeHesaplama/nakliyeHesaplamaSlice";
import InputAracType from "../../shared/input/nakliyeHesaplama/InputAracType";
import nakliyeFiyatHesaplamaAracOptions from "../../../utils/yukOptions/nakliyeFiyatHesaplamaAracOptions";
import useWindowDimensions from "../../../hooks/useWindowSize";
import CostContainer from "../partContainer/CostContainer";
import InputTonaj from "../../shared/input/nakliyeHesaplama/InputTonaj";
import InputJobDuration from "../../shared/input/nakliyeHesaplama/InputJobDuration";
import EnIyiRotaSvg from "../../icons/nakliyeHesaplama/EnIyiRotaSvg";
import OtobanSvg from "../../icons/nakliyeHesaplama/OtobanSvg";
import KopruSvg from "../../icons/nakliyeHesaplama/KopruSvg";
import DenizYoluSvg from "../../icons/nakliyeHesaplama/DenizYoluSvg";
import FerryPriceList from "../partContainer/FerryPriceList";
import HighwayPriceList from "../partContainer/HighwayPriceList";
import BridgePriceList from "../partContainer/BridgePriceList";
import formatConverter from "../../../helper/formatConverter";
import { IoFlag } from "react-icons/io5";
import Btn from "../../shared/button/Btn";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { showModal } from "../../../features/modal/modalSlice";

const Container = styled.div`
    width: ${({isControlContainerOpen}) => isControlContainerOpen ? "360px" : 0};
    transition: .3s;
    height: 100%;
    max-height: 100%;
    overflow-y: auto !important;
    overflow-x: hidden;
    border-right: ${({ isControlContainerOpen}) => isControlContainerOpen ? "1px solid" : "none"};
    border-color: ${({theme}) => theme.mainTextColor};
    color: ${({theme}) => theme.mainTextColor};
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    color: ${({theme}) => theme.mainTextColor};

    & *{
      display: ${({isControlContainerOpen}) => !isControlContainerOpen ? "none" : "block"};
      transition: .2s;
    }

    .title-container{
      width: 100%;
      padding: 20px;
      border-bottom: 1px solid ${({theme}) => theme.mainBorderColor};
      display: flex;
      justify-content: space-between;
      align-items: center;

      h2{
        font-size: var(--font-size-lg);
        font-weight: var(--font-weight-xl);
      }

      .question-icon{
        font-size: 1.4rem;
        cursor: pointer;
        color: ${({theme}) => theme.secondaryTextColor};
        transition: none;

        &:hover{
          color: ${({theme}) => theme.mainTextColor};
        }
      }

    }

    .extra-container{
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      width: calc(100% - 40px);
      margin: 20px;
      margin-bottom: ${({activeExtraPriceList}) => activeExtraPriceList ? 0 : "20px"};
      gap: 10px;

      .extra-item{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        gap: 5px;
        padding: 8px 0;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        cursor: pointer;
        width: 75px;

        .best-route-container{
          width: 40px;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50% !important;
          background-color: ${({isBestRoute, theme}) => isBestRoute ? "var(--color-main)" : theme.mainBgColor};
          border: 1px solid ${({isBestRoute, theme}) => isBestRoute ? "var(--color-main)" : theme.mainBorderColor};
        }

        .icon-container{
          height: 30px;
        }

        .extra-item-text{
          font-size: 12px;
          font-weight: var(--font-weight-md);
          text-align: center;
        }

        .price{
          font-size: 12px;
          font-weight: var(--font-weight-md);
        }

        :nth-child(2){
          background-color: ${({theme, activeExtraPriceList}) => activeExtraPriceList === 1 ? theme.secondaryBgColor : theme.mainBgColor};
        }

        :nth-child(3){
          background-color: ${({theme, activeExtraPriceList}) => activeExtraPriceList === 2 ? theme.secondaryBgColor : theme.mainBgColor};
        }
        
        :nth-child(4){
          background-color: ${({theme, activeExtraPriceList}) => activeExtraPriceList === 3 ? theme.secondaryBgColor : theme.mainBgColor};
        }
      }
    }
    
    .top-input-list-container{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px 0;
        background-color: ${({theme}) => theme.secondaryBgColor};

      }

    .input-container{
      display: flex;
      flex-direction: column;
      gap: 25px;
      padding: 20px;
      border-top: 1px solid ${({theme}) => theme.mainBorderColor};

    }

    .seperator{
      width: 300px !important;
      height: 3px;
      margin: 5px 20px;
      border-radius: 2px;
      background-color: ${({theme}) => theme.secondaryBgColor};
    }

    .route-list-container{
      display: flex;
      justify-content: space-between;
      padding: 20px;
      width: 100%;

      .route-item{
        border-radius: 5px;

        width: calc(33% - 15px);
        height: 52px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        gap: 3px;
        position: relative;
        border: 1px solid ${({theme}) => theme.mainTextColor};
        cursor: pointer;
        transition: none;

        .default-route{
          position: absolute;
          top: 3px;
          left: 3px;
        }

      }

      .selected-route-item{
        background-color: var(--color-main);
        color: #fff;
        border-color: transparent;
        transition: none;
      }
    }


    .static-data-container{
      display: flex;
      flex-direction: column;
      width: 100%;
      padding: 20px;
      padding-top: 5px;
      gap: 10px;

      .static-data-item{
        display: flex;
        align-items: center;
        font-size: var(--font-size-sm);
        gap: 10px;
        background-color: ${({theme}) => theme.secondaryBgColor};
        padding: 10px 18px;
        border-radius: 5px;


        .key{
          font-weight: var(--font-weight-lg);
        }

        .value{
          font-weight: var(--font-weight-md);

        }
      }

    }

    .bottom-btn-container{
      margin-bottom: 20px;
    }

`

const ControlContainer = () => {

    const {
      isControlContainerOpen,
      truckType,
      resCostData,
      kmData,
      tonajData,
      activeExtraPriceList,
      totalBridgePrice,
      totalFerryPrice,
      routeResultList,
      selectedRouteItem,
      totalHighwayPrice
    } = useSelector(state => state.nakliyeHesaplama)

    const {
      yakitData
    } = useSelector(state => state.calc)

    const {windowDimensions} = useWindowDimensions()
    
    const dispatch = useDispatch()

  return (
    <Container isControlContainerOpen={isControlContainerOpen} isBestRoute={routeResultList[0]?.routeToken === selectedRouteItem?.routeToken} activeExtraPriceList={activeExtraPriceList}>
      
      <div className="title-container">
        <h2>Nakliye Fiyatı Hesaplama</h2>
        <AiOutlineQuestionCircle className="question-icon" onClick={() => dispatch(showModal("nakliyeHesaplamaGuide"))}/>
      </div>

      <div className="extra-container">

        <div className="extra-item" onClick={() => {
          dispatch(updateActiveExtraPriceList(1));
          dispatch(updateSelectedRouteItem(routeResultList[0]));
          dispatch(updateKmData(routeResultList[0].localizedValues.distance.text))
          dispatch(setIsDurationStrict(false))
          }}>
          <div className="best-route-container">
            <EnIyiRotaSvg className="best-route-icon" isBestRoute={routeResultList[0]?.routeToken === selectedRouteItem?.routeToken}/>
          </div>
          <div className="extra-item-text">En iyi Rota</div>
        </div>

        <div className="extra-item" onClick={() => dispatch(updateActiveExtraPriceList(1))}>
          <div className="icon-container">
            <OtobanSvg className="best-route-icon"/>
          </div>
          <div className="extra-item-text">Otobanlar</div>
          <span className="price">{formatConverter(totalHighwayPrice, 0)} TL</span>
        </div>

        <div className="extra-item" onClick={() => dispatch(updateActiveExtraPriceList(2))}>
          <div className="icon-container">
            <KopruSvg className="best-route-icon"/>
          </div>
          <div className="extra-item-text">Köprüler</div>
          <span className="price">{formatConverter(totalBridgePrice, 0)} TL</span>
        </div>

        <div className="extra-item" onClick={() => dispatch(updateActiveExtraPriceList(3))}>
          <div className="icon-container">
            <DenizYoluSvg className="best-route-icon"/>
          </div>
          <div className="extra-item-text">Deniz Yolu</div>
          <span className="price">{formatConverter(totalFerryPrice, 0)} TL</span>
        </div>
      </div>

      {
        activeExtraPriceList &&
        <div className="top-input-list-container" onClick={(e) => e.stopPropagation()}>
          
          {
            activeExtraPriceList === 1 &&
            <HighwayPriceList/>
          }

          {
            activeExtraPriceList === 2 &&
            <BridgePriceList/>
          }

          {
            activeExtraPriceList === 3 &&
            <FerryPriceList/>
          }

        </div>
      }

      <div className="input-container">
        <InputAracType data={truckType} initialOptions={nakliyeFiyatHesaplamaAracOptions} inputWidth={windowDimensions.width <= 1400 ? "100%" : "320px"} labelText={"Araç Türü"} name={"nakliyeAracType"}/>
        <InputTonaj data={tonajData} labelText={"Tonaj"} initialOptions={nakliyeFiyatHesaplamaAracOptions} inputWidth={windowDimensions.width <= 1400 ? "100%" : "320px"} name={"nakliyeAracTonajOptions"}/>
        <InputJobDuration labelText={"İş Kaç Gün Sürecek"} inputWidth={windowDimensions.width <= 1400 ? "100%" : "320px"} name={"nakliyeIsKacGunSurecek"}/>
      </div>

      <div className="seperator"/>
      {
        (routeResultList.length > 0 ) &&
        <div className="route-list-container">
          {
            routeResultList.map((item, i) => (
                <div key={i} className={item?.routeToken === selectedRouteItem?.routeToken ? "selected-route-item route-item" : "route-item"} onClick={() => {dispatch(updateKmData(item.localizedValues.distance.text)); dispatch(updateSelectedRouteItem(item)); dispatch(setIsDurationStrict(false))}}>
                  <div className="point">{i+1}. Rota</div>
                  <div className="km-result">{item.localizedValues.distance.text}</div>
                  {
                    item.routeLabels[0] === "DEFAULT_ROUTE" &&
                  <IoFlag className="default-route" title="Varsayılan Rota"/>
                  }
                </div>
            ))
          }
        </div>
        }
        
        
        <div className="static-data-container">
          {
            yakitData &&
            <div className="static-data-item">
              <span className="key">Güncel Yakıt Fiyatı:</span>
              <span className="value">{yakitData} TL</span>
            </div>
          }

          {
            kmData &&
            <div className="static-data-item">
              <span className="key">Km:</span>
              <span className="value">{kmData}</span>
            </div>
          }
        </div>
        <div className="bottom-btn-container">
          <Btn color="var(--color-main)" height="35px" width={"200px"} handleClick={() => dispatch(clearNakliyeCalcForm())}>Formu Temizle</Btn>
        </div>
        {
          (resCostData?.highCost && resCostData?.midCost && resCostData?.lowCost && isControlContainerOpen) &&
          <CostContainer/>
        }

    </Container>
  )
}

export default ControlContainer